import React from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram, FaEnvelope } from 'react-icons/fa';

import * as S from './styles';

const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
  e.preventDefault();
  document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' });
};

export const Footer: React.FC = () => {
  return (
    <>
      <S.Container id="sobre">
        <div>
          <S.Logo as={Link} to="/">
            <img src="/assets/logo.svg" alt="Excursei" />
          </S.Logo>
          <S.FooterDesc>
            A plataforma mais simples para organizar excursões. Conectando
            organizadores e viajantes em uma experiência única.
          </S.FooterDesc>
          <S.SocialLinks>
            <S.SocialLink
              as="a"
              href="https://instagram.com/excursei_app"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <FaInstagram size={15} />
            </S.SocialLink>
            <S.SocialLink
              as="a"
              href="mailto:excursei.mailer@gmail.com"
              aria-label="Email"
            >
              <FaEnvelope size={15} />
            </S.SocialLink>
          </S.SocialLinks>
        </div>
        <S.Col>
          <h4>Navegação</h4>
          <a href="#sobre" onClick={(e) => handleClick(e, '#sobre')}>
            Sobre
          </a>
          <a href="#recursos" onClick={(e) => handleClick(e, '#recursos')}>
            Recursos
          </a>
          <a
            href="#como-funciona"
            onClick={(e) => handleClick(e, '#como-funciona')}
          >
            Como Funciona
          </a>
        </S.Col>
        <S.Col>
          <h4>Dúvidas</h4>
          <Link to="/politica-de-privacidade">Política de Privacidade</Link>
          <Link to="/termos-de-uso">Termos de Uso</Link>
          <a href="mailto:excursei.mailer@gmail.com">Suporte</a>
        </S.Col>
        <S.Col>
          <h4>Download</h4>
          <a href="#download" onClick={(e) => handleClick(e, '#download')}>
            Google Play
          </a>
        </S.Col>
      </S.Container>
      <S.Bottom>
        <span>© 2026 Excursei. Todos os direitos reservados.</span>
        <span>Feito com ❤️ para organizadores</span>
      </S.Bottom>
    </>
  );
};
